import IconButton from '@material-ui/core/IconButton'

import { getThemeImageUrl } from '../../utils'
import l10n from '../../../components/i18n/I18N'

import classes from './styles/notificationCloseButton.module.scss'

export const NotificationCloseButton = ({ closeToast }) => {
  return (
    <IconButton className={classes.notificationCloseButton} size="small" onClick={closeToast}>
      <img
        alt={l10n.t['icons.closeAlt']}
        src={getThemeImageUrl(classes.closeIcon)}
        className={classes.notificationCloseButton__icon}
      />
    </IconButton>
  )
}
